export default {"src":"/_next/static/media/full.0f99b855.svg","height":46,"width":117,"blurWidth":0,"blurHeight":0};